import axios from 'axios';
import { API_URL } from 'config/constants';

let apiTokenAuthorizationInterceptor;

const axiosInstance = axios.create({
    baseURL: API_URL
});

export const endPoints = {
    login: 'auth/login',
    logout: 'auth/logout',
    register: 'auth/register',
    forgotPassword: 'auth/forgot-password',
    resetPassword: 'auth/reset-password',
    firebaseToken: 'firebase-tokens',
    authedUser: 'me',
    requestOtp: 'request-verification-otp',
    verify: 'verify',
    categories: 'categories',
    presignedUrl: 'upload/signed-url',
    personalisationOptions: 'admin/personalisation-options',
    groups: 'groups',
    posts: 'posts',
    messaging: 'messaging',
    notifications: 'notifications',
    users: 'users',
    contents: 'contents',
    categoryGroups: 'category-groups',
    plans: 'subscriptions/plans',
    entitlements: 'entitlements',
    vouchers: 'admin/vouchers',
    voucherBulkCreate: 'admin/vouchers/bulk-create',
    companies: 'admin/companies',
    adminGroups: 'admin/groups',
    coaches: 'coaches',
    tickets: 'tickets',
    questions: 'admin/questions',
    questionnaires: 'admin/questionnaires',
    quizzes: 'admin/quizzes',
    quizzesStats: 'admin/quizzes/stats',
    quizContents: 'admin/contents',
    quizHealthJourneys: 'admin/health-journeys',
    healthJourneys: 'admin/health-journeys',
    healthDataExports: 'admin/exports/health-data',
    badges: 'admin/badges'

};

export function setAuthToken(token) {
    apiTokenAuthorizationInterceptor = axiosInstance.interceptors.request.use((config) => {
        config.headers.Authorization = `Bearer ${token || ''}`;

        return config;
    });
}

export function unsetAuthToken() {
    axiosInstance.interceptors.request.eject(apiTokenAuthorizationInterceptor);
}

export default axiosInstance;
